import $ from "jquery";
import ajaxSaveWishlist from "../../utils/libraries/ajax.save-wishlist";

const addToWishlist = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-add-to-wishlist",
    };

    if ($(el.button).length === 0) return;
    ajaxSaveWishlist(el.button, true);
  };

  init();
};

try {
  addToWishlist();
} catch (error) {
  console.error("addToWishlist", error);
}
